"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var ProductGalleryNative = /*#__PURE__*/function () {
  function ProductGalleryNative(component) {
    (0, _classCallCheck2["default"])(this, ProductGalleryNative);
    this.dom = {
      $component: component,
      $currentSlide: document.querySelector('.js-product-slider-gallery-counter'),
      $galleryImages: document.querySelectorAll(".ProductSliderGallery__item")
    }, this.state = {
      observer: false,
      supportsIntersectionObserver: 'IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype
    };
    this.mount();
  }

  (0, _createClass2["default"])(ProductGalleryNative, [{
    key: "mount",
    value: function mount() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('ProductGalleryNative : mount', this);

      if (state.supportsIntersectionObserver) {
        this.observe();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var self = this;
      var dom = this.dom;
      console.log('ProductGalleryNative : unmount', this);
    }
  }, {
    key: "observe",
    value: function observe() {
      var _this = this;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var activeSlide = e.target.getAttribute('data-imgnum');
            _this.dom.$currentSlide.innerHTML = activeSlide;
          }
        });
      }, {
        rootMargin: "0px",
        threshold: 0.51
      });
      this.dom.$galleryImages.forEach(function (e) {
        return io.observe(e);
      });
    }
  }]);
  return ProductGalleryNative;
}();

exports["default"] = ProductGalleryNative;